export const EVENT_CATEGORY = 'add_email';
export const REDIRECT_URL = 'https://m.p-y.tm/aee';
export const PAYTM_URL = 'https://paytm.com';
export const PAYTM_CARE_URL = 'https://paytm.com/care';
